import { useCallback } from "react";

import type { CustomMailSettingTestMailInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { SendCustomMailSettingMutationForRequestCreate } from "./mutation";

export const useSendCustomMailSettingForRequestCreate = () => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc } = useCustomMutation(SendCustomMailSettingMutationForRequestCreate);

	const sendTestMailAtRequestCreate = useCallback(
		async (input: CustomMailSettingTestMailInput) => {
			showLoadingScreenCallback();

			const { errors } = await mutationFunc({
				variables: {
					input,
				},
			}).finally(hideLoadingScreenCallback);

			if (!errors) {
				notifyUserEventInfo({
					title: "リクエスト予約を申請した際のテストメールを送信しました",
				});
			}
		},
		[hideLoadingScreenCallback, mutationFunc, showLoadingScreenCallback],
	);

	return { sendTestMailAtRequestCreate };
};
